<template>
  <div class="contents contents--home">
    <div class="home__boxs-container home__boxs-container-info">
      <div class="box">
        <div class="box-label">Block Height</div>
        <div class="box-value">
          <span>{{ blockHeight.toLocaleString() }}</span>
        </div>
      </div>

      <div class="box">
        <div class="box-label">Transactions</div>
        <div class="box-value">
          <span>{{ totalTx.toLocaleString() }}</span>
        </div>
      </div>
    </div>

    <div class="home__boxs-container home__boxs-container-info">
      <div class="box box--tx-history">
        <div class="box-label">Transaction History</div>
        <div class="box-value">
          <Chart :width="1098" :height="150" label="Transactions" />
        </div>
      </div>

      <!-- <div class="box">
        <div class="box-label">Total accounts</div>
        <div class="box-value">
          <Chart :width="520" :height="150" label="Accounts" />
        </div>
      </div>-->
    </div>

    <div class="home__boxs-container home__boxs-container-table">
      <div class="box">
        <div class="box-label">Recent Blocks</div>

        <Table width="523px" data-type="blocks" view="Home" :data="recentBlocks" />
        <router-link tag="button" class="button-view-all" to="/blocks">VIEW ALL</router-link>
      </div>

      <div class="box">
        <div class="box-label">Recent Transactions</div>

        <Table width="523px" data-type="txs" view="Home" :data="recentTxs" />
        <router-link tag="button" class="button-view-all" to="/txs">VIEW ALL</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Table from "./shared/Table.vue";
import Chart from "./shared/Chart.vue";
import callAPI from "../../api/http";
import { convertAttrFormat } from "../../js/format";
import { styleNav } from "../../js/style";
import EventBus from "../../js/event_bus";

export default {
  components: {
    Table,
    Chart,
  },

  async created() {
    this.blockHeight = await this.getBlockHeight();
    this.totalTx = await this.getTotalTx();
    this.recentBlocks = await this.getRecentBlocks();
    this.recentTxs = await this.getRecentTxs();

    setInterval(async (_) => {
      this.blockHeight = await this.getBlockHeight();
      this.totalTx = await this.getTotalTx();
      this.recentBlocks = await this.getRecentBlocks();
      this.recentTxs = await this.getRecentTxs();
    }, 10000);
  },

  mounted() {
    styleNav(1);
  },

  data() {
    return {
      blockHeight: 0,
      totalTx: 0,
      recentBlocks: null,
      recentTxs: null,
      limit: 10,
      offset: 0,
    };
  },

  methods: {
    async getRecentBlocks() {
      const { data, errCode } = await callAPI("getRecentBlocks");

      if (errCode) {
        console.log(errCode);
        return;
      }

      const { blocks } = data;
      return convertAttrFormat("BlocksList", blocks);
    },

    async getRecentTxs() {
      const { data, errCode } = await callAPI("getRecentTxs");

      if (errCode) {
        console.log(errCode);
        return;
      }

      const { txs } = data;
      return convertAttrFormat("TransactionsList", txs);
    },

    async getBlockHeight() {
      const { data, errCode } = await callAPI("getBlockHeight");
      if (errCode) {
        console.log(errCode);
        return;
      }

      const { block_height } = data;
      return block_height;
    },

    async getTotalTx() {
      const { data, errCode } = await callAPI("getTotalTx");

      if (errCode) {
        console.log(errCode);
        return;
      }

      const { total_tx } = data;
      return total_tx;
    },

    listenEvent() {
      EventBus.$on("pushBlock", ({ block }) => {
        if (this.blockHeight > block.block_number) {
          this.initializeRecentData();
        }

        this.blockHeight = block.block_number;
        this.block = convertAttrFormat("BlocksList", block);

        switch (this.limitBlocksFromWS < this.limit) {
          case true:
            this.recentBlocks.push(block);
            this.limitBlocksFromWS++;
            break;

          case false:
            this.recentBlocks.pop();
            this.recentBlocks.unshift(block);
            break;
        }
      });

      EventBus.$on("pushTransaction", ({ tx }) => {
        this.tx = convertAttrFormat("TransactionsList", tx);

        switch (this.limitTxsFromWS < this.limit) {
          case true:
            this.recentTxs.push(tx);
            this.limitTxsFromWS++;
            break;

          case false:
            this.recentTxs.pop();
            this.recentTxs.unshift(tx);
            break;
        }
      });
    },

    initializeRecentData() {
      this.recentBlocks = [];
      this.recentTxs = [];
      this.limitBlocksFromWS = 0;
      this.limitTxsFromWS = 0;
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/common";

.home__boxs-container {
  &-info {
    height: 220px;
    display: flex;
    margin-bottom: 10px;

    .box:first-child {
      margin-right: 10px;
    }

    .box {
      flex: 1;
      max-width: 565px;
      overflow-x: auto;
    }

    .box--tx-history {
      margin-right: 0 !important;
      max-width: initial;
    }
  }

  &-table {
    height: 612px;
    margin-bottom: 70px;
    display: flex;

    .box {
      width: 50%;
      max-width: 565px;
      overflow-x: hidden;

      &:first-child {
        margin-right: 10px;
      }
    }
  }
}

.box {
  padding: 15px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border: solid 1px #eeeeee;
  background-color: #ffffff;

  &-label {
    font-size: 14px;
    font-weight: bold;
  }

  &-value {
    flex: auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: auto;

    @include scroll(#ffffff);

    span {
      font-size: 40px;
      color: #0393f4;
    }
  }

  .button-view-all {
    align-self: center;
    width: 257px;
    height: 40px;
    box-sizing: border-box;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    border-radius: 20.5px;
    border: solid 1px #ebebeb;
    background-color: #ffffff;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/Home.vue